import { atom } from "recoil"
import { ATOMS_KEYS } from "../atom-keys"
import { IResponseGetUserDetail } from "src/services/home/getUserDetail/types"
export const userDetailsStore = atom<IResponseGetUserDetail>({
	key: ATOMS_KEYS.GETUSERDETAILS,
	default: undefined,
})
